module.exports = __webpack_public_path__ + "8ae5fd3.woff2";